import { RouteType } from "types/RouteType";

// Dashboard
import workflowsDashboardRoute from "./Dashboard/WorkflowsDashboard.Route";

// Core ReadyMix Workflows
import projectInitializationWorkflowRoute from "./ProjectInitialization/ProjectInitializationWorkflow.Route";
import dailyBatchLogWorkflowRoute from "./DailyBatchLog/DailyBatchLogWorkflow.Route";
import qcInspectionWorkflowRoute from "./QCInspection/QCInspectionWorkflow.Route";
import ncrWorkflowRoute from "./NCR/NCRWorkflow.Route";

// Estimating
import projectBidProposalWorkflowRoute from "./Estimating/ProjectBidProposal/ProjectBidProposalWorkflow.Route";

// Materials Management
import inventoryAdjustmentsWorkflowRoute from "./InventoryAdjustments/InventoryAdjustmentsWorkflow.Route";
import addRawMaterialsWorkflowRoute from "./AddRawMaterials/AddRawMaterialsWorkflow.Route";
import poRequisitionWorkflowRoute from "./PORequisition/PORequisitionWorkflow.Route";

// Maintenance
import laborTimeTrackingWorkflowRoute from "./LaborTimeTracking/LaborTimeTrackingWorkflow.Route";
import equipmentMaintenanceWorkflowRoute from "./EquipmentMaintenance/EquipmentMaintenanceWorkflow.Route";

// Quality Control
import toolCalibrationWorkflowRoute from "./QualityControl/ToolCalibration/ToolCalibrationWorkflow.Route";

// Dispatch & Fleet
import fleetDriverManagementWorkflowRoute from "./FleetDriverManagement/FleetDriverManagementWorkflow.Route";
import deliveryConfirmationWorkflowRoute from "./Dispatch/DeliveryConfirmation/DeliveryConfirmationWorkflow.Route";

// Field Operations
import fieldIssueWorkflowRoute from "./FieldOperations/FieldIssue/FieldIssueWorkflow.Route";
import warrantyClaimWorkflowRoute from "./WarrantyClaim/WarrantyClaimWorkflow.Route";
import safetyComplianceWorkflowRoute from "./FieldOperations/SafetyCompliance/SafetyComplianceWorkflow.Route";

// Project Management
import changeOrderWorkflowRoute from "./ChangeOrder/ChangeOrderWorkflow.Route";
import projectBillingWorkflowRoute from "./ProjectBilling/ProjectBillingWorkflow.Route";
import customerCommunicationWorkflowRoute from "./ProjectManagement/CustomerCommunication/CustomerCommunicationWorkflow.Route";

// Analytics
import reportBuilderWorkflowRoute from "./Analytics/ReportBuilder/ReportBuilderWorkflow.Route";

// NEW: ReadyMix-Specific Workflows
import batchTicketGenerationWorkflowRoute from "./BatchTicketGeneration/BatchTicketGenerationWorkflow.Route";
import mixDesignApprovalWorkflowRoute from "./MixDesignApproval/MixDesignApprovalWorkflow.Route";
import truckDispatchWorkflowRoute from "./TruckDispatch/TruckDispatchWorkflow.Route";
import deliveryTicketGenerationWorkflowRoute from "./DeliveryTicketGeneration/DeliveryTicketGenerationWorkflow.Route";
import slumpTestRecordingWorkflowRoute from "./SlumpTestRecording/SlumpTestRecordingWorkflow.Route";
import cylinderTrackingWorkflowRoute from "./CylinderTracking/CylinderTrackingWorkflow.Route";
import plantInventoryCheckWorkflowRoute from "./PlantInventoryCheck/PlantInventoryCheckWorkflow.Route";
import moistureCorrectionWorkflowRoute from "./MoistureCorrection/MoistureCorrectionWorkflow.Route";
import truckMaintenanceWorkflowRoute from "./TruckMaintenance/TruckMaintenanceWorkflow.Route";
import customerDeliverySchedulingWorkflowRoute from "./CustomerDeliveryScheduling/CustomerDeliverySchedulingWorkflow.Route";

const workflowsRoutesList: RouteType[] = [
  // Dashboard
  workflowsDashboardRoute,

  // Core Workflows
  projectInitializationWorkflowRoute,
  dailyBatchLogWorkflowRoute, // Renamed from DailyProductionLog for ReadyMix
  qcInspectionWorkflowRoute,
  ncrWorkflowRoute,

  // Estimating & Quoting
  projectBidProposalWorkflowRoute,

  // Materials Management (Raw Materials)
  inventoryAdjustmentsWorkflowRoute,
  addRawMaterialsWorkflowRoute,
  poRequisitionWorkflowRoute,

  // Maintenance
  laborTimeTrackingWorkflowRoute,
  equipmentMaintenanceWorkflowRoute,

  // Quality Control
  toolCalibrationWorkflowRoute,

  // Dispatch & Fleet Management
  fleetDriverManagementWorkflowRoute,
  deliveryConfirmationWorkflowRoute,

  // Field Operations
  fieldIssueWorkflowRoute,
  warrantyClaimWorkflowRoute,
  safetyComplianceWorkflowRoute,

  // Project Management
  changeOrderWorkflowRoute,
  projectBillingWorkflowRoute,
  customerCommunicationWorkflowRoute,

  // Analytics
  reportBuilderWorkflowRoute,

  // ========================================
  // ReadyMix-Specific Workflows
  // ========================================

  // Batch Plant Operations
  batchTicketGenerationWorkflowRoute,
  mixDesignApprovalWorkflowRoute,
  plantInventoryCheckWorkflowRoute,
  moistureCorrectionWorkflowRoute,

  // Truck Dispatch & Delivery
  truckDispatchWorkflowRoute,
  deliveryTicketGenerationWorkflowRoute,
  customerDeliverySchedulingWorkflowRoute,
  truckMaintenanceWorkflowRoute,

  // Quality Control (ReadyMix-Specific)
  slumpTestRecordingWorkflowRoute,
  cylinderTrackingWorkflowRoute,
];

export default workflowsRoutesList;
